import { myAxios } from "./axios"

export function getAllPersonalUse(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})

        },
    }
    return myAxios.get("/private-uses", config)
}

export function getPersonalUse(id) {
    return myAxios.get("/private-uses/" + id)
}

export function addPersonalUse(data) {
    return myAxios.post("/private-uses/create", data)
}

export function editPersonalUse(id, data) {
    return myAxios.put("/private-uses/" + id + "/update", data)
}

export function deletePersonalUse(id) {
    return myAxios.delete("/private-uses/" + id + "/delete")
}
